export default "__VITE_ASSET__BLb5Vep9__"